query useIssuesByKeyWithLinksQuery($cloudId: ID!, $keys: [String!]!) {
  jira {
    issuesByKey(cloudId: $cloudId, keys: $keys) {
      key
      webUrl
      issueLinks {
        edges {
          node {
            id
            relationName
            issueLinkId
            direction
            issue {
              key
              webUrl
            }
          }
        }
      }
    }
  }
}
